import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { Card, CardSubmitEvent } from '.';
import { renderElements, getStyles } from '@netcall/card-renderer';
import { nanoid } from 'nanoid';
import { onBeforeUnmount, onMounted, PropType, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CardRenderer',
  props: {
  cards: {
    type: Array as PropType<Card[]>,
    required: true,
  },
  colour: {
    type: String,
    required: true,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  location: {
    type: String,
    required: true,
  },
},
  emits: ["submit"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const id: string = `nc_${nanoid(7)}`;
const cardContainer = ref<HTMLElement | null>(null);

watch(
  () => props.cards,
  (cards: Card[]) => renderCards(cards),
);

onMounted(() => {
  renderCards(props.cards);
  document.addEventListener('fresco-panel-submit', cardSubmitHandler);
});

onBeforeUnmount(() => {
  document.removeEventListener('fresco-panel-submit', cardSubmitHandler);
});

function getCardStyles() {
  return getStyles(props.colour, id).innerHTML;
}

function renderCards(cards: Card[]) {
  if (!cardContainer.value) {
    return;
  }

  cardContainer.value.innerHTML = '';
  cards.forEach((card) => renderCard(card));
}

function renderCard(card: Card) {
  if (isCardComponentsValid(card)) {
    const cardJson = JSON.stringify(card.content.components);
    renderElements(card.id || '', cardJson, cardContainer.value, props.location, props.readonly);
  } else {
    renderError(card);
  }
}

function renderError(card: Card) {
  renderElements(card.id || '', '{}', cardContainer.value, props.location, props.readonly);
}

function isCardComponentsValid(card: Card) {
  return card.content && card.content && card.content.components && card.content.components.length > 0;
}

function cardSubmitHandler(e: Event) {
  const customEvent = e as CustomEvent;
  onSubmit(customEvent.detail);
}

function onSubmit(e: CardSubmitEvent) {
  emit('submit', e);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-reset", id])
  }, [
    _createElementVNode("div", {
      innerHTML: getCardStyles()
    }, null, 8, _hoisted_1),
    _createElementVNode("div", {
      ref_key: "cardContainer",
      ref: cardContainer,
      class: "card-container"
    }, null, 512)
  ]))
}
}

})